// 获取新闻列表
import { selectArticleList } from "@/request/article"

export default {
    namespaced:true,
    state:{
        articlelist1:[],
        page1:1,
        limit1:10,
        articlelist:[],
        page:1,
        limit:20,
        total:0
    },
    getters:{
        articlelist1:(state:any) => state.articlelist1,
        articlelist:(state:any) => state.articlelist,
        page:(state:any) => state.page,
        limit:(state:any) => state.limit,
        total:(state:any) => state.total,
    },
    mutations:{
        SET_LIST1(state:any,data:any){
            state.articlelist1 = data;
        },
        SET_LIST(state:any,data:any){
            state.articlelist = data;
        },
        SET_PAGE(state:any,data:any){
            state.page = data
        },
        SET_LIMIT(state:any,data:any){
            state.limit = data
        },
        SET_TOTAL(state:any,data:any){
            state.total = data
        },
        
    },
    actions:{
        async select_article_list1({state,commit}:any){
            const res = await selectArticleList(state.page1,state.limit1);
            commit("SET_LIST1",res.data.page.list)
        },
        async select_article_list({state,commit}:any){
            const res = await selectArticleList(state.page,state.limit);
            commit("SET_LIST",res.data.page.list)
            commit("SET_TOTAL",res.data.page.totalCount)
            return res
        },
        set_page({ commit, dispatch }:any, data:any) {
            commit('SET_PAGE', data)
            dispatch('select_article_list')
        },
        set_limit({ commit, dispatch }:any, data:any) {
            commit('SET_LIMIT', data)
            dispatch('select_article_list')
        }
        
    }
}